import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { Hub } from '../types/hub';

export class ProblemHub {
  hub: Hub;
  reason: string;
}

@Component({
  selector: 'problems',
  template: `<hubs-sub-menu></hubs-sub-menu>
<mat-checkbox [(ngModel)]="checkGap" (change)="onCheckToggled()">Long Gap</mat-checkbox>
<mat-checkbox [(ngModel)]="checkWakeSecs" (change)="onCheckToggled()">Avg Wake Secs</mat-checkbox>
<mat-checkbox [(ngModel)]="checkUptime" (change)="onCheckToggled()">Low Uptime</mat-checkbox>
<mat-checkbox [(ngModel)]="checkBattery" (change)="onCheckToggled()">Low Battery</mat-checkbox>
<mat-checkbox [(ngModel)]="checkAge" (change)="onCheckToggled()">No Recent Polls</mat-checkbox>
<mat-checkbox [(ngModel)]="checkVersion" (change)="onCheckToggled()">Old Version</mat-checkbox>
<mat-checkbox [(ngModel)]="checkWifiVersion" (change)="onCheckToggled()">Old Wifi Version</mat-checkbox>
<ul class="hubs">
  <li *ngIf="!!fromHubs && fromHubs.length > 0" (click)="prevPage()"><div class="button">Previous Page</div></li>
  <li *ngFor="let problem of problems"
      [style.background-color]="this.getColorFor(problem.hub)"
      (click)="gotoDetail(problem.hub)">
    <div class="serial">{{problem.hub.serial}}</div>
    <div class="details">
      <span class="name">{{problem.hub.name}}</span>
      <span class="reason">{{problem.reason}}</span>
    </div>
  </li>
  <li (click)="nextPage()"><div class="button">Next Page</div></li>
</ul>
`,
  styleUrls: ['./problems.component.css'],
  providers: [HubService],
})

export class ProblemsComponent implements OnInit {
  hubs: Hub[];
  problems: ProblemHub[];
  reasons: string[];
  currentHub: ProblemHub;
  errorMessage: any;
  fromHubs: number[] = [];
  pageLimit: number = 200;
  prevHubs: boolean = false;
  checkGap: boolean = true;
  checkWakeSecs: boolean = true;
  checkUptime: boolean = true;
  checkBattery: boolean = true;
  checkAge: boolean = true;
  checkVersion: boolean = true;
  checkWifiVersion: boolean = true;
  fromHub: number = 0;

  constructor(
    private hubService: HubService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    this.getHubs();
    document.getElementById('title').innerText = 'Problem Hubs';
  }

  getHubs(): void {
    this.hubService.getHubs(500, null, null, this.fromHub).subscribe(
      problems => this.gotHubs(problems),
      error => this.errorMessage = <any>error,
    );
  }

  nextPage() {
    console.log("Next page...");
    if (this.hubs) {
      // if (!this.fromHubs) this.fromHubs = [];
      this.fromHubs.push(this.hubs[0].hubid);
      this.fromHub = this.hubs[this.hubs.length-1].hubid;
      this.getHubs();
    }
  }

  prevPage() {
    console.log("Previous page...");
    if (this.fromHubs) {
      this.fromHub = this.fromHubs.pop();
      this.getHubs();
    }
  }

  gotHubs(hubs: Hub[]) {
    let problems: ProblemHub[] = [];
    for (let hub of hubs) {
      let r = '';
      if (this.checkGap && hub.gap > 1800) { r += (r ? ', ' : '') + 'poll gap > 1800s'; }
      if (this.checkWakeSecs && hub.avg_wake_secs > 25) { r += (r ? ', ' : '') + `wake seconds: ${hub.avg_wake_secs}`; }
      if (this.checkUptime && hub.uptime < 7200) { r += (r ? ', ' : '') + 'uptime < 2hr'; }
      if (this.checkBattery && hub.voltage > 1500 && hub.voltage < 3600) { r += (r ? ', ' : '') + `low battery: ${hub.voltage}mV`; }
      if (this.checkVersion && hub.swversion < '0.7.2') { r += (r ? ', ' : '') + 'old version: '+hub.swversion; }
      if (this.checkVersion && hub.swversion > '0.7.2' && hub.swversion < '0.9.18') { r += (r ? ', ' : '') + 'old version: '+hub.swversion; }
      if (this.checkWifiVersion && hub.wifi_version && hub.wifi_version < 300) { r += (r ? ', ' : '') + 'old wifi version: '+hub.wifi_version; }
      if (this.checkAge && hub.age > 86400) { r += (r ? ', ' : '') + 'last poll > 24h ago'; }
      if (this.checkAge && hub.age > 864000) { r = ''; }
      if (this.checkUptime && hub.uptime < 7200 && hub.age > 86400) { r = ''; }
      if (r) {
        problems.push(<ProblemHub>{
          hub: hub,
          reason: r,
        });
      }
    }
    this.problems = problems;
    this.hubs = hubs;
  }

  onCheckToggled() {
    console.log("Some value was toggled...");
    this.gotHubs(this.hubs);
  }
  
  gotoDetail(hub: Hub): void {
    this.router.navigate(['/hub', hub.hubid]);
  }

  getColorFor(hub: Hub): string {
    if (hub.gap > 7200 || hub.avg_wake_secs > 90 || hub.uptime <  200 || hub.version < '0.6.39') { return '#F4B8B8'; }
    if (hub.gap > 4800 || hub.avg_wake_secs > 80 || hub.uptime <  400 || hub.version < '0.6.44') { return '#F3C8C0'; }
    if (hub.gap > 3600 || hub.avg_wake_secs > 70 || hub.uptime <  800 || hub.version < '0.7.2') { return '#F2D8C8'; }
    if (hub.gap > 1800 || hub.avg_wake_secs > 60 || hub.uptime < 1600 || hub.version < '0.9') { return '#F1E8D0'; }
    if (hub.gap > 1200 || hub.avg_wake_secs > 50 || hub.uptime < 3200 || hub.version < '0.9.12') { return '#F0ECD8'; }
    if (hub.gap > 900  || hub.avg_wake_secs > 35 || hub.uptime < 6400) { return '#EFEEE0'; }
    if (hub.gap > 600  || hub.avg_wake_secs > 20 || hub.uptime < 25600) { return '#EEEEE8'; }
    return '#EEEEEE';
  }

}

